import 'styles/countryFlags.css'
import React, { useEffect, useState } from 'react'
import { Box, Flex, Image } from '@chakra-ui/react'
import { Outlet, useLocation } from 'react-router-dom'
import IBLogo from 'assets/images/logo-purple.svg'

import UserSide from 'assets/images/user-side.svg'
import PasswordSide from 'assets/images/password-side.svg'
import EmailSide from 'assets/images/email-side.svg'
import RecoverySide from 'assets/images/recovery-side.svg'

function SubscriberWrapper() {
  const [bgImage, setBgImage] = useState<string>(null)
  const location = useLocation()
  const { state }: any = useLocation()
  const { pageBefore } = state || {}
  const isBeforeRecoveryPage = pageBefore === 'recovery'
  const isRecoveryUser = pageBefore === 'recoveryUser500'
  const isRecoveryUserFailed = pageBefore === 'recoveryUser409' || pageBefore === 'subscriptionTokenInvalid' || pageBefore === 'recoveryTokenInvalid' 
  const isErrorCorreo =  isRecoveryUserFailed && location.pathname === '/suscripcion/error-correo' 
  const isErrorRecovery =  isRecoveryUserFailed && location.pathname === '/suscripcion/error-recuperar'
  const isErrorSuscription = location.pathname === '/suscripcion/error-suscripcion'
  const isError =  isErrorCorreo || isErrorRecovery || isErrorSuscription

  useEffect(() => {
    switch (location.pathname) {
      case '/lobby':
        return setBgImage(EmailSide)
      case '/suscripcion/usuario':
        return setBgImage(UserSide)
      case '/suscripcion/crear-administrador':
        return setBgImage(UserSide)  
      case '/suscripcion/contrasena':
          return setBgImage(PasswordSide)
      case '/suscripcion/correo':
          return setBgImage(isBeforeRecoveryPage ? RecoverySide : EmailSide)
      case '/suscripcion/datos':
      case '/suscripcion/validacion-identidad':
      case '/suscripcion/validacion-correo':
      case '/suscripcion/crear-cuenta':
      case '/suscripcion/creacion-exitosa':
        return setBgImage(EmailSide)
      case '/suscripcion/error-correo':        
        return setBgImage(isRecoveryUser ? RecoverySide : EmailSide)
      case '/suscripcion/error-recuperar':
        return setBgImage(isRecoveryUser ? RecoverySide : EmailSide)
      case '/suscripcion/recuperar-contrasena':
        return setBgImage(PasswordSide)
      case '/suscripcion/recuperar-usuario':
        return setBgImage(UserSide)
      case '/suscripcion/recuperar':
      case '/suscripcion/exito':
      case '/suscripcion/error':
      case '/suscripcion/error-crear-cuenta':
        return setBgImage(RecoverySide)
      case '/suscripcion/validacion-representante':
        return setBgImage(EmailSide)
      default:
        return setBgImage('')
    }
  }, [location])

  return (   
    <Flex style={{ height: '100vh' }}>
      {!isError  &&
      <>
      <Box p={8} bg='linear-gradient(180deg, #E8E0F9 0%, rgba(232, 224, 249, 0) 100%)' css={{ flex: 0.65, zIndex: 1, backdropFilter: 'blur(6px)' }}>
        <a href='/'>
          <Image
            h='27px'
            alt='Interbanking Logo'
            src={IBLogo}
          />
        </a>
        <Outlet />
      </Box>
      <Box style={{ display: 'flex', flex: 0.35, alignItems: 'center' }}>
        <Box position='absolute'>
          <Image src={bgImage} alt='Lateral image' boxSize='100vh' style={{ marginLeft: '-20vh', maxWidth: '120%' }} />
        </Box>
      </Box>
      </>
      }
      {isError &&
      <Box p={8} bg='white' css={{ flex: 1, zIndex: 1, backdropFilter: 'blur(6px)' }}>
        <Outlet />
      </Box>
      }
    </Flex>
  )
}

export default SubscriberWrapper
